import { render, staticRenderFns } from "./Bendahara.vue?vue&type=template&id=5a59c490&"
import script from "./Bendahara.vue?vue&type=script&lang=js&"
export * from "./Bendahara.vue?vue&type=script&lang=js&"
import style0 from "./Bendahara.vue?vue&type=style&index=0&id=5a59c490&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports